import { combineReducers } from "redux";
import auth from "./auth";
import app from "./app";
import insights from "./insights";
import webappPro from "./ProApp";
import webappPlus from "./PlusApp";
import { createBrowserHistory } from "history";
import { connectRouter } from "connected-react-router";
export const history = createBrowserHistory();

export default combineReducers({
  auth,
  app,
  insights,
  webappPro,
  webappPlus,
  router: connectRouter(history),
});
